<template>
    <div class="property-list-slider">
        <template
            v-if="pending || items.length === 0"
        >
            <transition name="fade">
                <div
                    v-if="!pending && items.length === 0"
                    class="property-list-slider__empty-state"
                >
                    <h3>
                        {{ $t('no-properties-found') }}
                    </h3>
                </div>
            </transition>

            <BaseSlider :items="[1,2,3]">
                <template
                    v-for="(item, index) in [1,2,3]"
                    #[`slide-${index}`]
                    :key="`slide-${index}`"
                >
                    <BaseCard
                        class="property-list__item"
                        :class="{
                            'property-list__item--empty-state': items.length === 0 || !pending
                        }"
                    >
                        <template #image>
                            <Skeletor
                                :shimmer="pending"
                                height="100%"
                            />
                        </template>

                        <template #header>
                            <Skeletor :shimmer="pending" />
                        </template>

                        <template #description>
                            <Skeletor
                                :shimmer="pending"
                                width="95%"
                            />
                            <Skeletor
                                :shimmer="pending"
                                width="85%"
                            />
                            <Skeletor
                                :shimmer="pending"
                                width="90%"
                            />
                        </template>

                        <template #meta>
                            <Skeletor
                                :shimmer="pending"
                                width="10rem"
                            />
                        </template>
                    </BaseCard>
                </template>
            </BaseSlider>
        </template>
        <BaseSlider
            v-else-if="items && items.length > 0"
            :items="items"
        >
            <template
                v-for="(item, index) in items"
                #[`slide-${index}`]
                :key="`slide-${index}`"
            >
                <LazyPropertyCard
                    :property="item"
                    :index="index"
                    class="property-list__item"
                />
            </template>
        </BaseSlider>
    </div>
</template>

<script setup>
defineProps({
    items: {
        type: Array,
        default: () => []
    },
    pending: {
        type: Boolean,
        default: false
    }
});
</script>

<style lang="less">
.property-list-slider {
    --offset-max: calc(var(--grid-gutter-margin) + ((100vw - var(--grid-maxWidth-page)) / 2) - var(--scrollbar-width, 0px));

    position: relative;
    overflow: hidden;

    @media ( max-width: @max-page-width ) {
        margin-left: calc(0rem - var(--grid-gutter-margin));
        margin-right: calc(0rem - var(--grid-gutter-margin));
        width: calc(100vw - var(--scrollbar-width, 0px));

        position: relative;
    }

    @media ( min-width: @max-page-width ) {
        margin-left: calc(0rem - var(--offset-max) - var(--scrollbar-width, 0px));
        margin-right: calc(0rem - var(--offset-max) - var(--scrollbar-width, 0px));
        width: calc(100vw - var(--scrollbar-width, 0px) - 1px);
    }

    .base-slider.slider {
        flex-direction: row;
    }

    a {
        .link-clean();
    }
}

.property-list-slider .slider__padding {
    scroll-snap-align: start;
    display: inline-block;
    flex: 0 0 auto;
    margin: 0;
}

.property-list-slider .slider__padding:first-child,
.property-list-slider__empty-state {
    width: clamp(
        calc(
            var(--grid-gutter-margin) +
            var(--filters-width)
        ), 100vw, calc(
            var(--offset-max) +
            var(--filters-width)
        )
    );
}

.property-list-slider .slider__padding:last-child {
    width: clamp(
        calc(
            var(--grid-gutter-margin)
        ), 100vw, calc(
            var(--offset-max)
        )
    );
}

.property-list-slider__empty-state {
    position: absolute;
    top: 50%;
    left: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    margin-left: calc(var(--filters-width) / 2);
    transform: translateY(-50%);
    overflow: hidden;
    text-align: center;
    padding: var(--grid-gutter-margin);

    opacity: 1;
    transition: opacity var(--transition--timing-medium) var(--transition-timingFunction-in-out);

    &.fade-enter-from,
    &.fade-leave-to {
        opacity: 0;
    }
}

.property-list__item--empty-state {
    opacity: .25;
}

.property-list--prefiltered {
    .property-list-slider__empty-state {
        margin-left: 0;
    }
}

/* BG FOR OVERLAY EFFECT */
.property-list-slider .slider__item {
    background: var(--color-cream);
    margin: 0;
    padding-left: var(--slider-gap);
}

.property-list-slider .slider__padding + .slider__item {
    padding-left: 0;
}

// Op verzoek van Robin fade weggehaald:
// .property-list__item--coming-soon {
//     .base-card__hoverable-image {
//         figure {
//             &:before {
//                 content: '';
//                 z-index: 10;
//                 width: 100%;
//                 height: 100%;
//                 display: block;
//                 position: absolute;
//                 background: #9D9D9D99 60%;
//             }
//         }
//     }
// }
</style>
